import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { CardMedia, Container, Grid, IconButton } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { Box, Button, Typography } from "components";
import { DefaultNavbar, PageLayout } from "modules";
import React from "react";
import Footer from "views/Auths/components/Footer";

const youTube = "";
const Founder = "";
const CoFounder = "";

const teams = [
  {
    id: 1,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
  {
    id: 2,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
  {
    id: 3,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
  {
    id: 4,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
  {
    id: 5,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
  {
    id: 6,
    name: "John Doe",
    description: "Lorem ipsum",
    imageUrl: "",
  },
];

const advisors = [
  {
    id: 1,
    name: "John Doe",
    iconUrl: <LinkedInIcon style={{ fill: "#0077b5" }} />,
    imageUrl: "",
  },
  {
    id: 2,
    name: "John Doe",
    iconUrl: <LinkedInIcon style={{ fill: "#0077b5" }} />,
    imageUrl: "",
  },
  {
    id: 3,
    name: "John Doe",
    iconUrl: <LinkedInIcon style={{ fill: "#0077b5" }} />,
    imageUrl: "",
  },
  {
    id: 4,
    name: "John Doe",
    iconUrl: <LinkedInIcon style={{ fill: "#0077b5" }} />,
    imageUrl: "",
  },
];

function AboutUs() {
  const navMenu = [
    { name: "How this works", route: "/how-this-works" },
    { name: "Pricing", route: "/pricing" },
    { name: "Contact", route: "/contact" },
  ];

  const handleClick = () => {
    window.open("https://in.linkedin.com/company/xaneai");
  };
  const handleEmailClick = () => {
    const mailtoLink = `mailto:`;
    window.open(mailtoLink);
  };
  return (
    <PageLayout>
      <DefaultNavbar transparent navMenu={navMenu} />
      <Box
        height="calc(100vh- 56px)"
        className="flex-display flex-direction-column justify-content-between"
      >
        <Container sx={{ height: "inherit", mt: pxToRem(16) }}>
          <Box
            className="height-100 flex-display flex-direction-column"
            gap={pxToRem(80)}
            width={{ xs: "100%", md: "82%" }}
            m="auto"
          >
            <Box className="flex-display flex-direction-column" gap={pxToRem(40)}>
              <Typography
                variant="h2"
                sx={({ breakpoints }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: pxToRem(20),
                  },
                })}
              >
                Get to know our talented crew of <br />
                <strong>creators, developers,</strong> and <strong>problem solvers</strong>
              </Typography>
              <Box sx={{ height: 420, width: "100%" }}>
                {/* <CardMedia
                  component="img"
                  image={poster}
                  title="Poster Image"
                  sx={{ objectFit: "cover", height: "100%", width: "100%" }}
                /> */}
              </Box>
              <Box
                className="flex-display"
                gap={pxToRem(16)}
                sx={({ breakpoints }) => ({
                  [breakpoints.down("md")]: {
                    flexDirection: "column",
                  },
                })}
              >
                <Typography variant="h4" className="width-100">
                  <strong>About Us</strong>
                </Typography>
                <Typography variant="subtitle2" sx={{ textAlign: "justify" }}>
                  Founded in 2017, Xane AI is an award winning B2B SaaS AI platform aimed at
                  revolutionizing user experience using Computer Vision and Natural Language
                  Processing to help organizations in creating personalized user experiences along
                  with automating their business processes eventually helping them reducing cost &
                  increasing business efficiency.
                </Typography>
                <Typography variant="subtitle2">
                  Within 2 years of being operational, Xane AI has a portfolio that spans across
                  various industries such as automobile, FMCG, healthcare, banking and
                  entertainment. Our consumer insights are helping companies across countries like
                  India, Netherlands, Bulgaria, Romania, Africa, Kuwait, US, UK and Philippines.
                </Typography>
              </Box>
            </Box>
            <Box height={pxToRem(420)}>
              <CardMedia
                component="img"
                image={youTube}
                title="Poster Image"
                height="100%"
                width="100%"
                sx={({ breakpoints }) => ({
                  [breakpoints.down("md")]: {
                    objectFit: "fill",
                    height: "100%",
                    width: "100%",
                  },
                })}
              />
            </Box>
            <Box className="flex-display flex-direction-column" gap={pxToRem(32)}>
              <Typography variant="h6">About our Teams</Typography>
              <Box className="flex-display flex-direction-column" gap={pxToRem(32)}>
                <Box
                  className="flex-display"
                  gap={pxToRem(32)}
                  sx={({ breakpoints }) => ({
                    [breakpoints.down("md")]: {
                      flexDirection: "column",
                    },
                  })}
                >
                  <Box className="flex-display flex-direction-column" gap={pxToRem(16)}>
                    <Box sx={{ height: 248 }}>
                      <CardMedia
                        component="img"
                        image={Founder}
                        title="Poster Image"
                        sx={{
                          objectFit: "fill",
                          height: "100%",
                          width: "100%",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>
                    <Box
                      className="flex-display"
                      sx={({ breakpoints }) => ({
                        [breakpoints.down("md")]: {
                          gap: pxToRem(16),
                          flexDirection: "column",
                        },
                      })}
                    >
                      <Typography variant="subtitle1" className="width-100">
                        <strong>Ayush Jain</strong> <br />{" "}
                        <Typography variant="caption">Founder & CEO</Typography>
                      </Typography>
                      <Typography variant="subtitle1" sx={{ textAlign: "justify" }}>
                        Ayush Jain started this venture just after completing his graduation from
                        IIT Delhi in May 2017. He has bootstrapped this venture from the development
                        of the product to selling it to organizations and getting first set of
                        paying clients. He believes that Persistence and Hard work which are two of
                        the most significant traits that are required to build great things.
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="flex-display flex-direction-column" gap={pxToRem(16)}>
                    <Box sx={{ height: 248 }}>
                      <CardMedia
                        component="img"
                        image={CoFounder}
                        title="Poster Image"
                        sx={{
                          objectFit: "fill",
                          height: "100%",
                          width: "100%",
                          borderRadius: pxToRem(8),
                        }}
                      />
                    </Box>
                    <Box
                      className="flex-display"
                      sx={({ breakpoints }) => ({
                        [breakpoints.down("md")]: {
                          gap: pxToRem(16),
                          flexDirection: "column",
                        },
                      })}
                    >
                      <Typography variant="subtitle1" className="width-100">
                        <strong> Sahil Narain </strong> <br />{" "}
                        <Typography variant="caption">Co-Founder & CTO</Typography>
                      </Typography>
                      <Typography variant="subtitle1" sx={{ textAlign: "justify" }}>
                        Ayush Jain started this venture just after completing his graduation from
                        IIT Delhi in May 2017. He has bootstrapped this venture from the development
                        of the product to selling it to organizations and getting first set of
                        paying clients. He believes that Persistence and Hard work which are two of
                        the most significant traits that are required to build great things.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    {teams.map((item) => (
                      <Grid item xs={6} md={4} key={item.id}>
                        <Box sx={{ height: 189, mb: "16px" }}>
                          <CardMedia
                            component="img"
                            image={item.imageUrl}
                            title="Poster Image"
                            sx={{
                              objectFit: "fill",
                              height: "100%",
                              width: "100%",
                              borderRadius: "8px",
                            }}
                          />
                        </Box>
                        <Typography variant="subtitle1" className="text-align-center">
                          <strong> {item.name} </strong> <br />{" "}
                          <Typography variant="caption">{item.description}</Typography>
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Box>
            <Box className="flex-display flex-direction-column" gap={pxToRem(32)}>
              <Typography variant="h6">Our Advisors</Typography>
              <Box className="flex-display flex-direction-column" gap={pxToRem(32)}>
                <Box>
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    {advisors.map((advisor) => (
                      <Grid item xs={6} md={3} key={advisor.id}>
                        <Box sx={{ height: 248, mb: "16px" }}>
                          <CardMedia
                            component="img"
                            image={advisor.imageUrl}
                            title="Poster Image"
                            sx={{
                              objectFit: "fill",
                              height: "100%",
                              width: "100%",
                              borderRadius: "8px",
                            }}
                          />
                        </Box>
                        <Box className="flex-container-column">
                          <Typography variant="subtitle1">
                            <strong> {advisor.name} </strong>
                          </Typography>
                          <IconButton onClick={handleClick}>{advisor.iconUrl}</IconButton>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Box>
            <Box
              className="flex-display flex-direction-column align-items-center"
              gap={pxToRem(32)}
              mb={pxToRem(32)}
            >
              <Box
                className="flex-display flex-direction-column text-align-center"
                gap={pxToRem(8)}
              >
                <Typography variant="h4">
                  <strong>Come work with us!</strong>
                </Typography>
                <Typography variant="subtitle1">
                  Write to us, tell us why you want to work with us and send your resume.
                </Typography>
              </Box>
              <Box>
                <Button onClick={handleEmailClick}>Email Us</Button>
              </Box>
            </Box>
          </Box>
        </Container>
        <Footer />
      </Box>
    </PageLayout>
  );
}
export default AboutUs;
